import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const ProcessSection = () => {
  const { t } = useLanguage();
  return (
    <section className="section-padding bg-slate"><div className="container-custom"><h2 className="text-3xl sm:text-4xl font-display font-bold text-night mb-4">{t('process.title')}</h2><p className="text-gray-600 text-lg">{t('process.subtitle')}</p></div></section>
  );
};

export default ProcessSection;
